import React from 'react';
import { useNavigate } from 'react-router-dom';

const FeaturedSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-8 bg-white">
      <div className="max-w-full mx-auto">
        <h2 className="text-2xl font-black mb-6 uppercase tracking-wide text-left px-16 lg:px-20">
          Featured
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
          {/* Top Left - Air Jordan */}
          <div className="relative overflow-hidden group cursor-pointer h-[400px] bg-gray-800" onClick={() => navigate('/products?category=Sports')}>
            <img 
              src="https://res.cloudinary.com/deejvhfyh/image/upload/v1763639461/heroes/hero3.jpg" 
              alt="Air Jordan 40 Edge PF" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8 text-white">
              <h3 className="text-3xl font-bold mb-4">Air Jordan 40 Edge PF</h3>
              <button className="bg-white text-black px-6 py-2 rounded-full font-semibold hover:bg-gray-200 transition-colors">
                Shop
              </button>
            </div>
          </div>

          {/* Top Right - Força Barça */}
          <div className="relative overflow-hidden group cursor-pointer h-[400px] bg-gray-700" onClick={() => navigate('/products?category=Fashion')}>
            <img 
              src="https://res.cloudinary.com/deejvhfyh/image/upload/v1763639460/heroes/hero2.jpg" 
              alt="Força Barça" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8 text-white">
              <h3 className="text-2xl font-bold mb-2">Força Barça!</h3>
              <p className="text-sm mb-4 max-w-md">Rep your favourite team on match day and beyond.</p>
              <button className="bg-white text-black px-6 py-2 rounded-full font-semibold hover:bg-gray-200 transition-colors">
                Shop
              </button>
            </div>
          </div>

          {/* Bottom Left - Get Set For Race Day */}
          <div className="relative overflow-hidden group cursor-pointer h-[400px] bg-gray-600" onClick={() => navigate('/products?category=Sports')}>
            <img 
              src="https://res.cloudinary.com/deejvhfyh/image/upload/v1763639459/heroes/hero1.jpg" 
              alt="Get Set For Race Day" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8 text-white">
              <h3 className="text-3xl font-bold mb-4">Get Set For Race Day</h3>
              <button className="bg-white text-black px-6 py-2 rounded-full font-semibold hover:bg-gray-200 transition-colors">
                Shop
              </button>
            </div>
          </div>

          {/* Bottom Right - New Arrivals */}
          <div className="relative overflow-hidden group cursor-pointer h-[400px] bg-gray-700" onClick={() => navigate('/products')}>
            <img 
              src="https://res.cloudinary.com/deejvhfyh/image/upload/v1763639462/heroes/hero4.jpg" 
              alt="New Arrivals" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-8 left-8 text-white">
              <h3 className="text-3xl font-bold mb-4">New Arrivals</h3>
              <button className="bg-white text-black px-6 py-2 rounded-full font-semibold hover:bg-gray-200 transition-colors">
                Shop
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
